import React from "react";
import CmsGrid from "./CmsGrid";
import { IGrid } from "../interfaces/IGrid";

const CmsTextContent : React.FC<{grid: IGrid}> = ({grid}) => {
    return <CmsGrid {...grid} />
}

export default CmsTextContent;